var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:url(#D\xE9grad\xE9_sans_nom);}.cls-4{fill:url(#D\xE9grad\xE9_sans_nom_2);}.cls-5{fill:#f59783;}.cls-6{fill:url(#D\xE9grad\xE9_sans_nom_3);}.cls-7{fill:url(#D\xE9grad\xE9_sans_nom_4);}.cls-8{fill:url(#D\xE9grad\xE9_sans_nom_5);}.cls-9{fill:#ee6438;}.cls-10{fill:url(#D\xE9grad\xE9_sans_nom_6);}.cls-11{fill:url(#D\xE9grad\xE9_sans_nom_7);}.cls-12{fill:url(#D\xE9grad\xE9_sans_nom_8);}.cls-13{fill:url(#D\xE9grad\xE9_sans_nom_9);}.cls-14{fill:url(#D\xE9grad\xE9_sans_nom_10);}.cls-15{fill:#f06649;}.cls-16{fill:#ec6321;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 70,
    height: 70
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom",
    x1: -253.47,
    y1: 321.57,
    x2: -253.46,
    y2: 319.77,
    gradientTransform: "matrix(32.59, 0, 0, -2.81, 8278.53, 942.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec6321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec6321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_2",
    x1: -253.47,
    y1: 321.62,
    x2: -253.46,
    y2: 319.82,
    gradientTransform: "matrix(32.59, 0, 0, -2.81, 8278.53, 939.68)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_3",
    x1: -310.14,
    y1: 362.27,
    x2: -309.17,
    y2: 360.99,
    gradientTransform: "matrix(4.94, 0, 0, -4.25, 1587.04, 1580.86)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_4",
    x1: -346.26,
    y1: 235.93,
    x2: -345.3,
    y2: 234.66,
    gradientTransform: "matrix(1.22, -2.51, -1.64, -0.8, 866.49, -630.64)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_5",
    x1: -253.35,
    y1: 435.01,
    x2: -253.37,
    y2: 434.55,
    gradientTransform: "matrix(32.31, 0, 0, -18.21, 8231.32, 7945.5)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_6",
    x1: -271.92,
    y1: 426.33,
    x2: -274.73,
    y2: 422.79,
    gradientTransform: "matrix(19.07, 0, 0, -12.92, 5242.87, 5511.34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec6321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f06649"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_7",
    x1: -239.31,
    y1: 402.92,
    x2: -239.8,
    y2: 401.89,
    gradientTransform: "matrix(12.22, 0, 0, -7.14, 2950.59, 2907.64)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_8",
    x1: -241.04,
    y1: 400.06,
    x2: -240.63,
    y2: 401.19,
    gradientTransform: "matrix(12.78, 0, 0, -6.99, 3099.39, 2836.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f06649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f06649"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_9",
    x1: -496,
    y1: 426.97,
    x2: -499.3,
    y2: 426.54,
    gradientTransform: "matrix(0.42, -0.87, -12.46, -6.06, 5539.6, 2183.53)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_10",
    x1: -239.29,
    y1: 402.87,
    x2: -239.79,
    y2: 401.84,
    gradientTransform: "matrix(12.22, 0, 0, -7.14, 2960.31, 2885.06)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17257",
    "data-name": "Groupe 17257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17255",
    "data-name": "Groupe 17255"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5705",
    "data-name": "Rectangle 5705",
    className: "cls-3",
    d: "M3,48.28H35.59v.93a1.88,1.88,0,0,1-1.88,1.88H5.81A2.81,2.81,0,0,1,3,48.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5706",
    "data-name": "Rectangle 5706",
    className: "cls-4",
    d: "M3,45.09H35.59v.56a2.25,2.25,0,0,1-2.25,2.25H5.81A2.81,2.81,0,0,1,3,45.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5707",
    "data-name": "Rectangle 5707",
    className: "cls-5",
    d: "M4,44H34.53a1.05,1.05,0,0,1,1.06,1.05H3A1,1,0,0,1,4,44Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17256",
    "data-name": "Groupe 17256"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_414",
    "data-name": "Ellipse 414",
    className: "cls-6",
    cx: 63.15,
    cy: 49.74,
    rx: 2.47,
    ry: 2.13,
    transform: "translate(-9.19 84.79) rotate(-64.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5708",
    "data-name": "Rectangle 5708",
    className: "cls-7",
    d: "M60.12,48.81l.43-.87a.91.91,0,0,1,1.22-.43h0a.92.92,0,0,1,.42,1.22l-.42.88a.92.92,0,0,1-1.22.42h0A.91.91,0,0,1,60.12,48.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12115",
    "data-name": "Trac\\xE9 12115",
    className: "cls-8",
    d: "M61.13,47a5.64,5.64,0,0,1-1.31,2.67,1.58,1.58,0,0,1-1.52.5c-5.54-1.11-17.15-8.28-28.42-14.55-.75-.42-1.27-.89-.92-1.62l.78-1.59c.35-.72,1.19-.32,2,0,11.92,4.9,24.57,9.17,28.91,13.13A1.57,1.57,0,0,1,61.13,47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5709",
    "data-name": "Rectangle 5709",
    className: "cls-9",
    d: "M27.58,34.68l2-4a.93.93,0,0,1,1.24-.43h0a.92.92,0,0,1,.43,1.24l-2,4a.93.93,0,0,1-1.24.43h0A1,1,0,0,1,27.58,34.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5710",
    "data-name": "Rectangle 5710",
    className: "cls-9",
    d: "M15.85,29.26l2-4a.93.93,0,0,1,1.24-.43h0A.93.93,0,0,1,19.48,26l-2,4a.94.94,0,0,1-1.25.43h0A.93.93,0,0,1,15.85,29.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5711",
    "data-name": "Rectangle 5711",
    className: "cls-10",
    x: 13.19,
    y: 24.75,
    width: 19.07,
    height: 12.92,
    transform: "translate(-15.28 38) rotate(-64.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5712",
    "data-name": "Rectangle 5712",
    className: "cls-5",
    x: 17.27,
    y: 33.5,
    width: 2.4,
    height: 12.92,
    transform: "translate(-25.54 39.1) rotate(-64.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12116",
    "data-name": "Trac\\xE9 12116",
    className: "cls-11",
    d: "M24.23,42.89,23.71,44a.74.74,0,0,1-.88.38,36.15,36.15,0,0,1-10.5-5.11.73.73,0,0,1-.24-.92l.52-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12117",
    "data-name": "Trac\\xE9 12117",
    className: "cls-12",
    d: "M25.32,41.46l-.26.52a.36.36,0,0,1-.49.17L12.78,36.42a.37.37,0,0,1-.17-.49l.25-.52a.37.37,0,0,1,.5-.17L25.15,41A.37.37,0,0,1,25.32,41.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5713",
    "data-name": "Rectangle 5713",
    className: "cls-13",
    d: "M12.73,35.67h0a.5.5,0,0,1,.65-.23L25,41.08a.47.47,0,0,1,.23.64h0a.5.5,0,0,1-.65.23L13,36.31A.48.48,0,0,1,12.73,35.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5714",
    "data-name": "Rectangle 5714",
    className: "cls-5",
    x: 26.29,
    y: 14.96,
    width: 2.4,
    height: 12.92,
    transform: "translate(-3.79 36.77) rotate(-64.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12118",
    "data-name": "Trac\\xE9 12118",
    className: "cls-14",
    d: "M33.35,24.14l.52-1.07a.75.75,0,0,0-.24-.94A36.64,36.64,0,0,0,23.13,17a.73.73,0,0,0-.87.39l-.53,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12119",
    "data-name": "Trac\\xE9 12119",
    className: "cls-15",
    d: "M32.9,25.88l.25-.52a.38.38,0,0,0-.17-.5L21.19,19.13a.38.38,0,0,0-.5.17h0l-.25.52a.37.37,0,0,0,.17.49L32.4,26.05a.38.38,0,0,0,.5-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12120",
    "data-name": "Trac\\xE9 12120",
    className: "cls-16",
    d: "M33,25.72l.1-.21A.36.36,0,0,0,32.9,25L21.11,19.28a.37.37,0,0,0-.49.18h0l-.1.2a.35.35,0,0,0,.17.49l11.79,5.74a.37.37,0,0,0,.49-.17Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuction);
export default __webpack_public_path__ + "static/media/auction.a005b0537bcf235782be47a3e893eb39.svg";
export { ForwardRef as ReactComponent };